
import { motion } from 'framer-motion';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function MentionsLegalesPage() {
  const sections = [
    {
      title: '1. Éditeur du Site',
      content: 'Le site Pixel-anim est édité par Pixel-anim, société spécialisée dans la création de contenus numériques personnalisés. Siège social : [Adresse à compléter]. Email : contact@pixel-anim.com. Directeur de la publication : [Nom à compléter].'
    },
    {
      title: '2. Hébergement',
      content: 'Le site Pixel-anim est hébergé par [Nom de l\'hébergeur à compléter], dont le siège social est situé à [Adresse à compléter]. Téléphone : [Numéro à compléter].'
    },
    {
      title: '3. Propriété Intellectuelle',
      content: 'L\'ensemble du contenu de ce site (textes, images, vidéos, logos, icônes, sons, logiciels) est la propriété exclusive de Pixel-anim ou de ses partenaires. Toute reproduction, représentation, modification, publication ou adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite sans autorisation écrite préalable.'
    },
    {
      title: '4. Crédits',
      content: 'Design et développement : Pixel-anim. Illustrations : Créations originales Pixel-anim. Icônes : Remix Icon. Polices : Google Fonts (Fredoka, Quicksand). Photographies : Banques d\'images libres de droits et créations originales.'
    },
    {
      title: '5. Limitation de Responsabilité',
      content: 'Pixel-anim s\'efforce d\'assurer l\'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, Pixel-anim ne peut garantir l\'exactitude, la précision ou l\'exhaustivité des informations mises à disposition sur ce site. Pixel-anim ne pourra être tenue responsable des dommages directs ou indirects résultant de l\'accès au site ou de l\'utilisation du site.'
    },
    {
      title: '6. Liens Hypertextes',
      content: 'Le site Pixel-anim peut contenir des liens hypertextes vers d\'autres sites. Pixel-anim n\'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu. L\'existence d\'un lien hypertexte entre le site Pixel-anim et un autre site ne constitue pas une validation de ce site ou de son contenu.'
    },
    {
      title: '7. Cookies',
      content: 'Le site Pixel-anim utilise des cookies pour améliorer l\'expérience utilisateur et analyser le trafic. Les cookies sont de petits fichiers texte stockés sur votre appareil. Vous pouvez configurer votre navigateur pour refuser les cookies, mais certaines fonctionnalités du site pourraient ne pas fonctionner correctement.'
    },
    {
      title: '8. Données Personnelles',
      content: 'Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d\'un droit d\'accès, de rectification, de suppression et d\'opposition au traitement de vos données personnelles. Pour exercer ces droits, contactez-nous à : contact@pixel-anim.com. Pour plus d\'informations, consultez notre Politique de Confidentialité.'
    },
    {
      title: '9. Droit Applicable',
      content: 'Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d\'accord amiable, le litige sera porté devant les tribunaux français conformément aux règles de compétence en vigueur.'
    },
    {
      title: '10. Contact',
      content: 'Pour toute question concernant les mentions légales ou le site Pixel-anim, vous pouvez nous contacter par email à contact@pixel-anim.com ou via notre formulaire de contact.'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
        <div className="max-w-7xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center"
          >
            <h1 className="text-5xl md:text-6xl font-fredoka font-bold text-gray-900 mb-6">
              Mentions{' '}
              <span className="bg-gradient-to-r from-primary-blue via-purple-600 to-primary-coral bg-clip-text text-transparent">
                Légales
              </span>
            </h1>
            <p className="text-lg font-quicksand text-gray-600 max-w-3xl mx-auto">
              Informations légales et éditoriales du site Pixel-anim
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white rounded-4xl p-8 md:p-12 shadow-soft border border-gray-100"
          >
            <div className="space-y-8">
              {sections.map((section, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.05 }}
                  className="border-b border-gray-100 pb-6 last:border-b-0"
                >
                  <h2 className="text-2xl font-fredoka font-bold text-gray-900 mb-4">
                    {section.title}
                  </h2>
                  <p className="font-quicksand text-gray-700 leading-relaxed">
                    {section.content}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Contact Info */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="mt-12 p-6 bg-gradient-to-br from-primary-blue/20 to-purple-100 rounded-3xl"
            >
              <h3 className="text-xl font-fredoka font-bold text-gray-900 mb-3">
                Besoin de plus d'informations ?
              </h3>
              <p className="font-quicksand text-gray-700 mb-4">
                Notre équipe est disponible pour répondre à toutes vos questions concernant les mentions légales de notre site.
              </p>
              <a
                href="/contact"
                className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 text-white font-quicksand font-semibold rounded-full hover:bg-gray-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                <span>Nous contacter</span>
              </a>
            </motion.div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
